(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["toni-testimonials"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('toni-testimonial-carousel')) {
    customElements.define('toni-testimonial-carousel', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-review-track]');
        this.slides = [...this.querySelectorAll('[data-review-slide]')];
        this.controls = this.querySelector('[data-review-controls]');
        this.previous = this.querySelector('[data-review-previous]');
        this.next = this.querySelector('[data-review-next]');
        this.position = this.querySelector('[data-review-position]');
        if (!this.track || !this.slides.length) return;
        this.abortController?.abort();
        this.resizeObserver?.disconnect();
        this.abortController = new AbortController();
        const options = { signal: this.abortController.signal };
        this.previous.addEventListener('click', () => this.move(this.first - 1), options);
        this.next.addEventListener('click', () => this.move(this.first + 1), options);
        this.track.addEventListener('scroll', () => {
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(() => this.update());
        }, { ...options, passive: true });
        this.track.addEventListener('keydown', (event) => {
          if (event.target !== this.track) return;
          const targets = { ArrowLeft: this.first - 1, ArrowRight: this.first + 1, Home: 0, End: this.slides.length - 1 };
          if (!(event.key in targets)) return;
          event.preventDefault();
          this.move(targets[event.key]);
        }, options);
        this.resizeObserver = new ResizeObserver(() => this.update());
        this.resizeObserver.observe(this.track);
        this.update();
      }

      disconnectedCallback() {
        this.abortController?.abort();
        this.resizeObserver?.disconnect();
        cancelAnimationFrame(this.frame);
      }

      update() {
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        this.step = this.slides[0].getBoundingClientRect().width + gap;
        if (!this.step) return;
        const visible = Math.max(1, Math.round((this.track.clientWidth + gap) / this.step));
        this.maximum = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
        this.first = Math.max(0, Math.min(this.slides.length - visible, Math.round(this.track.scrollLeft / this.step)));
        const last = Math.min(this.slides.length, this.first + visible);
        const label = visible > 1 ? `${this.first + 1}-${last} / ${this.slides.length}` : `${this.first + 1} / ${this.slides.length}`;
        if (this.position.textContent !== label) this.position.textContent = label;
        this.previous.disabled = this.track.scrollLeft <= 2;
        this.next.disabled = this.track.scrollLeft >= this.maximum - 2;
        this.controls.hidden = this.maximum <= 2;
      }

      move(index) {
        this.track.scrollTo({
          left: Math.max(0, Math.min(index * this.step, this.maximum)),
          behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
